import { render } from "./PostJobView.vue?vue&type=template&id=f11e4ac8"
import script from "./PostJobView.vue?vue&type=script&lang=js"
export * from "./PostJobView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__